export { NileSideBarFooterText } from './nile-side-bar-footer-text';